// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"Skeleton_skeleton__HR16e","loading":"Skeleton_loading__LN1IA"};